import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import {
	optionalDateAsIsoString,
	refineDateOrder,
	trimmedNullable,
} from "web_myplann/Shared/Validation/zodHelpers";
import { z } from "zod";

export const getCryptocurrencyFormSchema = (t: TranslateFunction) => {
	return z
		.object({
			name: trimmedNullable(
				z
					.string()
					.min(1, t(Resources.Portfolio.AddShared.Validations.required))
					.max(
						ValidationLimits.TextLength.LongName,
						t(Resources.Portfolio.AddShared.Validations.maxLength, {
							max: ValidationLimits.TextLength.LongName,
						}),
					),
			),
			contractNumber: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.Name,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.Name,
					}),
				),
			),
			producer: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			product: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			productCategoryId: z.number().nullable(),
			signedAt: optionalDateAsIsoString(),
			startAt: optionalDateAsIsoString(),
			endAt: optionalDateAsIsoString(),
		})
		.superRefine(
			refineDateOrder({
				startBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.startBeforeSigned,
				),
				endBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.endBeforeSigned,
				),
				endBeforeStart: t(
					Resources.Portfolio.AddShared.Validations.endBeforeStart,
				),
			}),
		);
};

export type CryptocurrencyFormInput = z.input<
	ReturnType<typeof getCryptocurrencyFormSchema>
>;
export type CryptocurrencyFormOutput = z.output<
	ReturnType<typeof getCryptocurrencyFormSchema>
>;
